import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { CabinSection } from "@/components/site/CabinSection";
import { Reviews } from "@/components/site/Reviews";
import { Location } from "@/components/site/Location";
import { Footer } from "@/components/site/Footer";
import { useT } from "@/lib/i18n";

export default function Home({ lang, setLang }) {
  const t = useT(lang);

  return (
    <div className="bg-paper min-h-screen" data-testid="home-page">
      <Navbar lang={lang} setLang={setLang} />

      <main>
        <Hero lang={lang} />

        <section
          id="cabins"
          data-testid="cabins-section"
          className="relative py-24 sm:py-32"
        >
          <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <div className="max-w-2xl mb-12">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#8a6a44] mb-4">
                Two Cabins · One View
              </div>
              <h2
                data-testid="cabins-heading"
                className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#4a3520] leading-[1.05]"
              >
                {t.cabins.heading}
              </h2>
              <p className="text-[#5a4530] mt-4 text-base sm:text-lg max-w-xl">
                {t.cabins.sub}
              </p>
            </div>

            <Tabs defaultValue="S1" className="w-full">
              <TabsList
                data-testid="cabin-tabs"
                className="bg-[#efe5d3] border border-[#a17a4c]/30 rounded-full p-1 h-auto mb-10 inline-flex"
              >
                <TabsTrigger
                  data-testid="cabin-tab-S1"
                  value="S1"
                  className="rounded-full px-6 py-2.5 text-sm data-[state=active]:bg-[#8a6a3f] data-[state=active]:text-[#f7f1e6] text-[#3d2a1b] transition"
                >
                  {t.cabin.s1_name}
                </TabsTrigger>
                <TabsTrigger
                  data-testid="cabin-tab-S2"
                  value="S2"
                  className="rounded-full px-6 py-2.5 text-sm data-[state=active]:bg-[#8a6a3f] data-[state=active]:text-[#f7f1e6] text-[#3d2a1b] transition"
                >
                  {t.cabin.s2_name}
                </TabsTrigger>
              </TabsList>

              <TabsContent value="S1" className="mt-0">
                <CabinSection cabinKey="S1" lang={lang} />
              </TabsContent>
              <TabsContent value="S2" className="mt-0">
                <CabinSection cabinKey="S2" lang={lang} />
              </TabsContent>
            </Tabs>
          </div>
        </section>

        <Reviews lang={lang} />
        <Location lang={lang} />
      </main>

      <Footer lang={lang} />
    </div>
  );
}
